import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  display: flex;
  gap: 5px;
`;

export const LinkText = styled.p`
  color: ${({ theme }) => theme.primary.accent};
  font-family: Manrope;
  font-size: 12px;
  cursor: pointer;
`;

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <LinkText
        onClick={() => {
          navigate(-1);
        }}
      >
        Back
      </LinkText>
    </Container>
  );
};

export default BackButton;
